import React from "react";
import clsx from "clsx";

const RightArrow = ({ className, width = "24", fill = "#fff" }) => {
  return (
    <svg className={clsx([className])} viewBox="0 0 89.35 39.36" width={width}>
      <polygon
        points="89.35 19.68 69.67 0 66.48 3.2 80.7 17.42 0 17.42 0 21.94 80.7 21.94 66.48 36.16 69.67 39.36 89.35 19.68 89.35 19.68 89.35 19.68"
        fill={fill}
      />
    </svg>
  );
};

RightArrow.propTypes = {};

export default RightArrow;
